<template>
  <div class="header_wrap">
    <div class="container">
      <div class="header_mall">
        <h1>
          <a href="/"><img src="../assets/images/mall_logo.svg" alt="" /></a>
        </h1>
        <div class="gnb_wrap">
          <ul class="mall_gnb">
            <li><a href="/timeDeal">타임딜</a></li>
            <li><a href="/">공구상품</a></li>
            <li>
              <a v-if="isSeller == 1" href="javascript:void(0);" @click="goSettlement">정산내역</a>
            </li>
            <li><a :href="isEmpty(idntCode) ? '/orderInquiry' : '/orderList'">주문내역</a></li>
            <li><a href="javascript:void(0);" @click="goInquiry">1:1문의</a></li>
          </ul>
          <div class="info">
            <a v-if="isEmpty(idntCode)" @click="login()">로그인</a>
            <a v-else @click="logout()">로그아웃</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="kakao-inquiry">
    <a href="http://pf.kakao.com/_xjfeXn/chat" target="_blank">
      <img src="../assets/images/kakao_inquiry.svg" />
    </a>
  </div>
  <!-- <div class="header">
    <div class="header-wrap">
      <h1>
        <img src="../assets/images/mall_logo.svg" alt="" />
      </h1>
      <div class="right">
        <RouterLink to="/orderInquiry" class="btn">주문내역</RouterLink>
      </div>
    </div>
  </div> -->
</template>

<script setup>
import { ref, watch, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { isEmpty } from 'lodash';
import {
  _formatAmount,
  _setStorageWithExpiry,
  _getStorageWithExpiry,
  _safeBtoa,
  _getIsGonggu,
  _getIsPassed,
  _getPeriodStatus,
  _safeAtob,
} from '../utils/common.js';
import api from '@/utils/api.js';
import { trackViewItemList } from '@/utils/ga.js';

const LOGIN_URL = 'https://tble.kr/login.php?url=mallLogin';
const loginPopup = ref(null);
const idntCode = ref('');
const isSeller = ref('');
const router = useRouter();
const route = useRoute();

onMounted(() => {
  const id = _safeAtob(_getStorageWithExpiry('id'));
  const sy = _safeAtob(_getStorageWithExpiry('sy'));
  idntCode.value = id;
  isSeller.value = sy;
  window.addEventListener('message', handleMessage);
  trackViewItemList(location.pathname);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);

  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.close();
    }
  } catch (e) {
    console.log(e);
  }
});

function handleMessage(event) {
  const { type, mb_id, sy, hp } = event.data;
  console.log(event.data, '@@@@');

  if (type == 'tble') {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.close();
    }

    _setStorageWithExpiry('id', _safeBtoa(mb_id));
    _setStorageWithExpiry('sy', _safeBtoa(sy));
    _setStorageWithExpiry('hp', _safeBtoa(hp));

    idntCode.value = mb_id;
    setIdntCode(mb_id);

    const allowPaths = ['/', '/orderComplete', '/timeDeal'];
    const isProductDetail = route.path.startsWith('/productDetail/');

    if (!allowPaths.includes(route.path) && !isProductDetail) {
      router.push('/');
    }
  }
}

async function setIdntCode(id) {
  const response = await api.post('/tble.php', {
    mode: 'add',
    idnt_code: id,
  });

  if (response.data) {
    console.log('IDNT_CODE 응답:', response.data);
  } else {
    console.error('IDNT_CODE 응답에 결과가 없습니다.');
  }
}
function login() {
  const currentUrl = encodeURIComponent(window.location.href);

  // if (isMobile()) {
  //   window.location.href = `${LOGIN_URL}&dv=m&uri=${currentUrl}`;
  //   return;
  // }

  const loginUrl = `${LOGIN_URL}&uri=${currentUrl}`;

  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.focus();
      return;
    }
  } catch (e) {
    console.log(e);
  }

  const width = 480;
  const height = 720;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${Math.max(0, left)}`,
    `top=${Math.max(0, top)}`,
    'resizable=yes',
    'scrollbars=yes',
  ].join(',');

  try {
    if (loginPopup.value && !loginPopup.value.closed) {
      loginPopup.value.location.href = loginUrl;
      loginPopup.value.focus();
      return;
    }
  } catch (e) {
    loginPopup.value = null;
  }

  loginPopup.value = window.open(loginUrl, 'tbleMallLogin', features);
  if (!loginPopup.value) {
    alert('팝업이 차단되었습니다.');
    return;
  }
  loginPopup.value.focus();
}

function isMobile() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function logout() {
  ['id', 'sy', 'hp'].forEach(k => sessionStorage.removeItem(k));
  idntCode.value = null;

  const isTimeDeal = route.path === '/timeDeal';
  const isProductDetail = route.path.startsWith('/productDetail/');

  if (!isTimeDeal && !isProductDetail) {
    router.push('/');
  }
}

function goInquiry() {
  if (isEmpty(idntCode.value)) {
    alert('로그인이 필요한 서비스입니다.');
    return;
  }
  router.push('/inquiryList');
}

function goSettlement() {
  window.open('https://tble.kr/mall/state.php', '_blank');
}
</script>
